import React from "react";
import { Helmet } from "react-helmet";

let TermsAndConditionsImgs = [
  "https://ezmarketingtech.s3.amazonaws.com/img/seo_traffic_bg.jpg",
];

const TermsAndConditions = () => {
  return (
    <>
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Terms & Conditions | EZ Marketing Agency</title>
        <meta
          name="description"
          content="Read the Terms & Conditions of EZ Marketing Agency, a California-based digital marketing firm offering SEO, PPC, content marketing, and other digital marketing services."
        />
        <meta
          name="keywords"
          content="EZ Marketing Agency terms, digital marketing agency California, SEO agency, PPC, content marketing, marketing services policy"
        />
        <meta name="author" content="EZ Marketing Agency" />
        <link
          rel="canonical"
          href="https://www.ezmarketing.agency/terms-and-conditions"
        />
        <meta property="og:title" content="Terms & Conditions | EZ Marketing Agency" />
        <meta
          property="og:description"
          content="Read the Terms & Conditions of EZ Marketing Agency, a California-based digital marketing firm offering SEO, PPC, content marketing, and other digital marketing services."
        />
        <meta
          property="og:image"
          content="https://ezmarketingtech.s3.amazonaws.com/img/seo_traffic_bg.jpg"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.ezmarketing.agency/terms-and-conditions" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <section className="cancellation_policy_section">
        <figure className="policy_figure">
          <img
            src={TermsAndConditionsImgs[0]}
            alt="Terms and Conditions Banner"
            width="100%"
          />
        </figure>
        <div className="terms_policy_detail ">
          <div className="container">
            <h1>Terms & Conditions</h1>
            <p>
              Welcome to EZ Marketing Agency. These terms & conditions govern the provision of our marketing services to you.
            </p>

            <strong>Who Are We?</strong>
            <p>
              At EZ Marketing Agency, we help businesses grow smarter and faster through data-driven digital marketing. Our team of experts crafts tailored campaigns that connect brands with their audiences and deliver measurable results.
            </p>
            <p>
              We blend creativity with analytics to make marketing simple, effective, and ROI-focused. Headquartered in California, we partner with businesses across industries that want to scale their presence and performance online.
            </p>

            <p>By accepting our proposal, you agree to the following terms and conditions:</p>

            <strong>Service Agreement</strong>
            <p>
              All services are delivered based on written proposals or agreements that define project scope, deliverables, and payment terms. You agree to provide all necessary access, materials, and timely feedback.
            </p>

            <strong>Scope of Services</strong>
            <p>
              We provide digital marketing and related marketing services as described in your agreement. The following are the services we offer:
            </p>
            <ul className="policy_list">
              <li>Amazon SEO</li>
              <li>Pay Per Click / Adwords</li>
              <li>Content Marketing</li>
              <li>Social Media Marketing</li>
              <li>Reputation Management</li>
              <li>E-Commerce SEO</li>
            </ul>

            <strong>Client Responsibilities</strong>
            <p>
              You agree to provide accurate information, timely approvals, and access to relevant accounts or materials required for the project. Delays caused by missing or incorrect information may affect delivery timelines.
            </p>

            <strong>Payments</strong>
            <p>
              All fees, schedules, and payment terms are specified in your proposal or invoice. All payments will be processed through STRIPE. We reserve the right to suspend services in case of any payment discrepancies.
            </p>

            <strong>Intellectual Property</strong>
            <p>
              EZ Marketing Agency retains ownership of all pre-existing tools, templates, and materials used in providing services. Upon full payment, you receive a limited, non-exclusive license to use the final deliverables for your intended business purposes.
            </p>

            <strong>Limitation of Liability</strong>
            <p>
              EZ Marketing Agency’s total liability for any claim shall not exceed the total fees paid in the preceding period. We are not liable for any indirect or consequential losses.
            </p>

            <strong>Modifications</strong>
            <p>
              We may update these terms occasionally to reflect operational or legal changes. The most current version will be posted or shared, and continued use of our services constitutes acceptance of any updates.
            </p>

            <strong>Governing Law</strong>
            <p>
              EZ Marketing Agency complies with the California Online Privacy Protection Act (CalOPPA), ensuring maximum transparency about data collection, usage, and sharing. Our Terms & Conditions explain the types of data we collect, how that information is used, and how users can manage their personal data. For more details, you can refer to the full
              <a
                href="https://leginfo.legislature.ca.gov/faces/codes_displayText.xhtml?division=8.&chapter=22.&lawCode=BPC"
                target="_blank"
                rel="nofollow noreferrer"
              >
                {" "}CalOPPA
              </a>.
            </p>

            <strong>Contact Information</strong>
            <p>
              For questions or concerns, please contact{" "}
              <a href="mailto:sales@ezmarketing.agency">sales@ezmarketing.agency</a>.
            </p>

            <p>
              By using our website or engaging our services, you confirm that you have read, understood, and agreed to these Terms & Conditions.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsAndConditions;
